import component from './UserAvatar.vue'
export default component
